import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN';
export default {
  message: '系统登录',
  welecome: '欢迎',
  layer: {
    toggle: '您确定要切换语言版本吗?',
    tips: '语言切换',
    welcome: '欢迎使用！',
  },
  button: {
    humilis:'保存成功',
    search: '搜索',
    Reset: '清空',
    New: '新增',
    New1: '新增',
    NewMer: '新增商户',
    NewDevice: '新增设备',
    NewAgent: '新增代理商',
    NewSalesman: '新增业务员',
    Modify: '修改',
    OK: '确定',
    Cancel: '取消',
    Shops: '店铺',
    Shops1: '店铺',
    Shops2: '店铺列表',
    Merchant: '商户',
    Enabled: '启用',
    Enabled1: '启用',
    Enabled2: '启用',
    Suspended: '停用',
    Suspended1: '停用',
    Suspended2: '停用',
    Suspended3: '停用',
    Approval: '审核',
    Approve: '审核通过',
    Approve1: '审核不通过',
    Reject: '拒绝',
    Reject1: '拒绝',
    EnterDetail: '进入详情',
    Return: '返回',
    RefreshStatus: '刷新交易状态',
    SaveResult: '导出搜索结果',
    delete: '删除',
    Resubmit: '重新提交',
    Manage: '管理',
    Refresh: '刷新',
    Close: '关闭',
    // V2.7新增字段
    view: '查看大图',
    // V2.8新增字段
    loading: '加载中',
    sending: '发送中',
    colon: '：',
    save: '保存',
    saveTime: '保存时间',
    saveMer: '已保存商户',
    cancelMer:'未保存商户',
    edit: '编辑',
  },
  search: {
    //交易流水
    RefNo: '系统流水号',
    RefNo1: '系统流水号',
    SubAccountNo: '子商户号',
    // 2.5新增字段
    WechatRMBWallet: '微信支付',
    WechatMOPWallet: '微信支付 MO',
    WechatHKDWallet: '微信支付 HK',
    WeChatPayCatering: ' 微信支付（餐饮）', // 2.16新增
    AlipayHK: '支付宝 HK', // 2.6新增
    Alipay: '支付宝', // 2.6新增
    Conditions:'暂无结果，请重置条件查找',
    SubAccountNo3: '支付宝HK商户号',
    SubAccountNo4: '支付宝商户号',
    ServiceChargeRate2: '支付宝HK手续费率（%）',
    ServiceChargeRate3: '支付宝手续费率（%）',
    channelInfo: '通道资料',
    channelInfo1: '通道资料',
    SubAccountNo2: '微信支付商户号',
    HKSubAccountNo: '微信支付 HK 商户号',
    WalletType: '钱包类别', // 2.6废弃
    RMBWallet: '人民币钱包', // 2.6废弃
    HKDWallet: '港币钱包', // 2.6废弃
    RMBOrHKD: '人民币钱包商户号或港币钱包商户号',
    Channel: '通道',
    PursePain: '前宝通机构',
    wherewithal:'Allinpay 机构',
    // 2.6新增
    CrossBorderWallet: '跨境钱包',
    HongKongWallet: '香港钱包',
    SweepPay: '刷卡支付',
    ScanPay: '扫码支付',
    Review:"微信审核状态",
    wereNot:"未审核",
    associates:"审核通过",
    Audit:"审核中",
    partnership:"审核驳回",
    // V2.14新增
    SweepPay1: '付款码支付',

    SubAccountNo1: '子商户号',
    AgentName: '所属代理商',
    AgentName2: '所属代理商',
    MerchantName: '商户名称',
    MerchantName1: '商户名称',
    MerchantName2: '商户名称',
    TransactionCompleted: '交易结果',
    TransactionCompleted1: '交易结果',
    TransactionCompleted2: '交易结果',
    Select:'选择通道',
    YES: '是',
    NO: '否',
    Yes: '成功',
    No: '失败',
		refunding: '处理中',
    remarks:'用户备注',
    Institutional:'机构模式',
    TransactionType: '交易类型',
    TransactionType1: '交易类型',
    WeChatPaySweep: '微信刷卡支付',
    WeChatPayScan: '扫码支付',
    OAPayment: '公众号支付',
    SelectBeginTime: '交易时间',
    SelectBeginTime1: '订单时间',
    SelectEndTime: '',
    TransactionStatus: '结算状态',
    TransactionStatus1: '结算状态',
    SettledDone: '已结算',
    NotSettled: '未结算',
    //商户
    AgentName1: '代理商名称',
    AccountStatus: '商户状态',
    Pending: '未审核',
    Rejected: '审核未通过',
    EstablishmentDate: '入网时间',
    //代理商
    levelID: '代理商编号',
    levelID1: '代理商编号',
    UpperLevel: '上级代理名称',
    UpperLevel1: '上级代理名称',
    UpperLevel2: '上级代理名称',
    Status: '代理商状态',
    Status1: '代理商状态',
    Status2: '代理商状态',

    // V2.13新增
    websitePayment: '网页支付',
    PC2Mobile: '网页支付',
    WAPPayment: 'WAP 支付',
    APPPayment: 'APP 支付',
    bankCardPayment: '银行卡支付',

    // v2.21新增相关海关字段
    Undeclared:'未申报',
    DeclarationSubmit:'申报已提交',
    Reporting:'申报中',
    DeclarationSuccess:'申报成功',
    DeclarationFail:'申报失败',
    ApiError:'海关接口异常'
  },
  placeH: {
    All: '所有',
    Please: '请选择',
    Required: '(必填)',
  },
  hint: {
    supplement:'请补充通道商户号',
    ThePictureSizeMustNotExceed5M: '上传图片大小不能超过 5MB',
    MandatoryFieldsAreNotFilledIn: '必填项未填写',
    usernameDoesNotExist: '用户不存在',
    pwdErr: '密码错误，请重新登录',
    loading: '请稍候再试',
    pleaseRelogin: '闲置时间过长，请重新登录',
    BuildFailed: '生成失败',
    NoData: '无数据',
    Alert: '提示',
    Success: '成功',
    Success1: '成功',
    Fail: '失败',
    Fail1: '失败',
    SureTo: '确定',
    SuccessfullyModified: '修改成功',
    FailToEdit: '修改失败',
    ThisAgent: '该代理商吗?',
    TheAdditonOf: '该店铺的进件申请吗?',

    TheAdditonOf1: '确定批准该商户的信息修改吗?',
    TheAdditonOf3: '确定拒绝该商户的信息修改吗?',

    TheAdditonOf4: '确定批准该商户的进件申请吗?',
    TheAdditonOf5: '确定拒绝该商户的进件申请吗?',

    TheAdditonOf6: "确定批准该店铺的信息修改吗?",
    TheAdditonOf7: "确定拒绝该店铺的信息修改吗?",
    TheAdditonOf8: "确定批准该店铺的进件申请吗?",
    TheAdditonOf9: "确定拒绝该店铺的进件申请吗?",

    TheAdditonOf2: '该代理商的进件申请吗?',
    TheShopInfoChange: '该店铺的信息修改吗?', //店铺信息修改
    TheMerchantInfoChange: '该商户的信息修改吗?',
    TheAgentInfoChange: '该代理商的信息修改吗?',
    Approved: '审核成功',
    Rejected: '审核失败',
    OperationSuccess: '操作成功',
    OperationFail: '操作失败',
    CreateOK: '提交成功',
    CreateFailed: '提交失败',
    ChangeOK: '修改成功',
    ChangeFailed: '修改失败',

    PleaseEnterName: '请输入姓名',
    PleaseEnterBDStaffNumber: '请输入业务员编号',
    PleaseEnterIDNumber: '请输入身份证号码',
    PleaseEnterPhoneNumber: '请输入联系电话',
    PleaseEnterEmail: '请输入电邮',
    BDStaffNumberIsValid: '业务员编号验证通过',
    BDStaffNumberExistsPleaseReEnter: '业务员编号已存在，请重新输入',
    BDRecordCreated: '新增业务员成功',
    BDCreateFailed: '新增业务员失败',
    LengthIsMax25Characters: '长度在 0 到 25 个字符',
    LengthIsMax10Characters: '长度在 0 到 10 个字符',
    LengthIsMax20Characters: '长度在 0 到 20 个字符',
    LengthIsMax11Characters: '长度在 0 到 11 个字符',
    LengthIsMax50Characters: '长度在 0 到 50 个字符',

    //商户
    SureToChangeInfoOfTheMerchant: '确定修改商户信息吗?',
    SureToAddThisMerchant: '确定增加该商户吗?',
    SureToEnableThisMerchant: '确定启用该商户吗?',
    SureToSuspendThisMerchant: '确定停用该商户吗?',
    PhoneNumberAlreadyExists: '手机号码已存在',
    PhoneNumberAlreadyExists1: '座机已存在',
    OfficePhoneNumberAlreadyExists: '公司号码已存在',
    TheMerchantIsDisabled: '商户已停用',
    TheMerchantIsEnabled: '商户已启用',
    //店铺
    SureToChangeInfoOfTheShop: '确定修改店铺信息吗?',
    SureToSuspendThisShop: '确定停用该店铺吗?',
    SureToEnableThisShop: '确定启用该店铺吗?',
    SureToApproveTheShopInfoChange: '确定批准该店铺的信息修改吗?',
    SureToRejectTheShopInfoChange: '确定拒绝该店铺的信息修改吗?',
    SureToApproveTheAdditonOfTheShop: '确定批准该店铺的进件申请吗?',
    SureToRejectTheAdditionOfTheShop: '确定拒绝该店铺的进件申请吗?',
    SureToAddThisShop: '确定新增该店铺吗?',
    //代理商
    SureToEnableThisAgent: '确定启用该代理商吗?',
    SureToSuspendThisAgent: '确定停用该代理商吗?',
    SureToChangeInfoOfTheSalesman: '确定修改该业务员信息吗?',
    SureToChangeInfoOfTheAgent: '确定修改该代理商信息吗?',
    SureToAddThisAgent: '确定新增该代理商吗?',
    ApproveChangeOfInformation: '确定通过该代理商信息修改吗？',
    ApproveRegistration: '确定通过该代理商进件申请吗？',
    SureToRejectThisAgentInfoChange: '确定拒绝该代理商的信息修改吗?',
    SureToRejectTheAdditionOfThisAgent: '确定拒绝该代理商的进件申请吗?',
    SubmittedApprovalPending: '已提交，审核中',
    TheAgentIsDisabled: '代理已停用',
    TheAgentIsEnabled: '代理已启用',
    //机构
    SureToAddThisOrganization: '确定新增该机构吗?',
    SureToChangeInfoOfTheOrganization: '确定修改该机构吗?',
    ThisOrganization: '该机构吗?',

    MerchantNameAlreadyExists: '商户名称已存在',
    AgentNameAlreadyExists: '代理商名称已存在',
    SubaccountAlreadyExists: '子商户号已存在',
    // 2.5新增字段
    accountAlreadyExists: '人民币钱包商户号已存在',
    HKaccountAlreadyExists: '港币钱包商户号已存在',

    PhoneNumberAlreadyExists: '手机号码已存在',
    ShopNameAlreadyExists: '店铺名称已存在',
    CompanyNameAlreadyExists: '公司名称已存在',
    InstitutionNameAlreadyExists: '机构名称已存在',
    EmailAlreadyExists: '业务员电邮已存在',
    ContactPersonsEmailAlreadyExists: '联系人邮箱地址已存在',

    EmailAlreadyExists: '邮箱地址已存在',

    EmailFormatIncorrect: '邮箱格式不正确,请重新输入',
    pleaseEnter: '请输入',
    pleaseInput: '请填写', // 2.5新增字段
    PleaseAddMerchantOrShopPhoto: "请添加公司或店铺照片",

    // 2.3新增字段
    // 广告管理
    addImage: '添加图片',
    confirmToLaunchThisAdvertisement: '确定发布该广告吗?',
    pleaseInputAdvertisementLink: '请输入链接',
    paymentPage: '付款成功页',
    aPPHomePage: 'APP首页',

    //2.4新增字段
    //公司
    confirmToDisableThisMcompany: '确定停用该公司吗?',
    confirmToEnableThisMcompany: '确定启用该公司吗?',
    confirmToMakeTheChanges: '确定修改公司信息吗?',
    TheCompanyIsDisabled: '公司已停用',
    TheCompanyIsEnabled: '公司已启用',
    SureToAddThisCompany: '确定新增该公司吗?',
    ApproveChangeOfInformationC: '确定通过该公司信息修改吗？',
    ApproveRegistrationC: '确定通过该公司进件申请吗？',
    SureToRejectThisCompanyInfoChange: '确定拒绝该公司的信息修改吗?',
    SureToRejectTheAdditionOfThisCompany: '确定拒绝该公司的进件申请吗?',
    //资金管理
    confirmToWithdraw: '确定提现HK$ ',
    doubt: '吗?',
    withdrawAmountShouldBeNoLessThan: '兑现金额不能小于HK$ ',

    // V2.6
    pleaseInputAccountNo: '请填写商户号',
    pleaseInputServiceChargeRate: '请填写微信支付手续费率',
    pleaseSelectServiceChargeBearer: '请选择手续费承担方',
    pleaseInputServiceChargeRateHK: '请填写微信支付HK手续费率',
    pleaseInputServiceChargeRate2: '请填写支付宝HK手续费率',
    pleaseInputServiceChargeRate3: '请填写支付宝手续费率',
    alipayAccountAlreadyExists: '支付宝商户号已存在',
    alipayHKAccountAlreadyExists: '支付宝HK商户号已存在',

    //2.8
    Confirmthewithdrawalrequestof: '确认',
    hasbeenpaid: '的提现申请已打款?',
    PaymentConfirmation: '确认打款',
    CancelConfirmation: '取消确认',
    Confirmtogiveuptheexport: '确认放弃导出吗?',

    // 2.10新增字段
    alipayDirectHasAlreadyExist: '支付宝(直连)商户号已存在',
    WeChatPayHKNoHasAlreadyExist: '微信支付 HK商户号已存在',
    feeRateFormatIncorrect: '手续费率格式错误',
    confirmRefund: '确认退款',
    PleaseInputMerchantName: '请填写商户名称',
    PleaseSelectPassingRules: '请选择放行规则',

    //V2.12
    notice: '提示：银联订单当天退款只支持全额退款',

    // V2.13
    pleaseInputServiceChargeRate4: '请填写支付宝(线上)手续费率',
    SubAccountNo5: '支付宝(线上)商户号',

    // V2.15
    pleaseInputRejectReasons: '请填写驳回原因',

  },
  login: {
    User: '用户',
    pwd: '密码',
    Login: '登录',
    PasswordShouldBeAtLeast6Characters: '密码不能少于6位',
  },
  index: {
    UniversalPocketPaymentManagement: '前宝通支付管理',
    Welcome: '欢迎您,',
    Number: '序号',
    Operation: '操作',
    UnipockPaymentSystemAdministration: '前宝通支付管理系统',
    Location: '当前位置',
    Entrance: '欢迎页',
    Logout: '退出登录',
    MiPay: 'MiPay支付系统管理',
    MerchantOrders: '企业商户交易报表.xls',
    amendmentApprovalPending: '修改信息审核中',
    newShopApprovalPending: '新增店铺审核中',
    Salesman: '业务员管理',
    Device: "设备管理",
    searchResults: '搜索结果',
    approval: '审核管理',
    personnel: '人员管理',
    fund: '资金管理',
    name: "名称",
    name1: "商户名称",
    status: '商户状态',
    MerchantInfoExcel:'商户资料',
  },
  //交易流水
  trade: {
    jumped:'交易时段',
    stock:'交易笔数',
    WeChatPay: '微信支付',
    MerchantRef: '交易流水',
    MerchantRef1: '交易流水',
    TransactionNo: '交易流水号',
    MerchantRefNo: '商户流水号',
    Agent: '所属代理商',
    Time: '交易时间',
    PaymentTime: '支付时间',
    originated: '交易金额',
    AmountCNY: '金额(CNY)',
    TransactionType: '交易类型',
    Payment: '收款',
    Refund: '退款',
    PaymentMethod: '支付方式',
    Device: '设备',
    DeviceID: '设备编号',
    Staff: '操作员',
    OrderNumber: '订单号',
    whetherToPay: '是否付款',
    Box: '派派小盒',
    AppPay: 'APP支付',
    MiniProgram: '小程序支付',
    SubordinateMerchant: 'API支付',
    OriginalTransactionNumber: '原系统流水号',
    MerchantTransactionNumber: '商户流水号',
    LANDIA8: '联迪A8',

    // 2.3新增字段
    // 交易流水表
    merchantNumber: '商户编号',
    fee: '手续费',
    receivableAmount: '实收金额',
    totalAmount: '总交易金额',
    totalorder:'总交易笔数',
    totalsuccess:'交易成功笔数',
    volume:'总数',
    tabulation :'已添加商户列表',
    utilization:'交易成功率',
    blanking:'成功交易最大间隔',
    between:'成功交易最小间隔',
    business:'添加统计商户',
    totalFee: '总手续费',
    Remarks: '备注',
    rejectReasons: '驳回原因:',
    transaction: '交易管理',
    frozenAmount: '冻结金额',
    // V2.7新增字段
    TransactionNumber: '订单编号',
    Refundable: '可退金额',
    RefundAmount: '退款金额',
    Amount: '金额',
    PleaseEnterRefundAmount: '请输入退款金额',
    ExceededMaximum50Refunds: '该笔订单退款已达到 50 次',
    InsufficientBalanceForThisRefund: '账户余额不足以支持退款',
    CannotRefundUnfinishedTransaction: '失败订单无法进行退款',
    ExceededRefundablePeriodOf365Days: '该笔订单已超过 365 天',
    ExceededRefundablePeriodOf540Days: '该笔订单已超过 540 天',
    ExceededRefundablePeriodOf24Hours: '该笔订单已超过 24 小时',
    onlyOfflineBankCardRefundIsSupported: '仅支持线下银行卡退款',
    Maximum: '最大值',
    Minimum: '最小值',
    export: '导出',

    // V2.10新增字段
    Unionpay: '银联',
    H5Payment: 'H5 支付',
    HideTestMer: '隐藏测试商户',

    failureReason: '失败原因',
    userRemarks: '用户备注',
    merchantRemark: '商户备注',

    // v2.21新增字段
    transactionDetails:'交易详情',
    Details:'详情',
    merInfo:'商户信息',
    orderInfo:'订单信息',
    deviceInfo:'设备信息',
    remarksInfo:'备注信息',
    CustomColumns:'自定义列',
    Pay:'支付',
    SerialNumber:'流水号',
    WalletType:'钱包类型',

    // 报关管理
    Administration:'报关管理',
    RecordName:'备案名称',
    CustomsDeclarationTime:'报关时间',
    CustomsDeclarationNo:'报关编号',
    CustomsDeclarationStatus:'报关状态',
    customsList:'报关列表',
    CustomsFailureReason:'报关失败原因'

  },
  //商户
  mer: {
    Registration: '进件',
    Amendment: '修改信息',
    PendingMerchantApproval: '待审核商户',
    MerchantAddress: '商户地址',
    AccountBalance: '账户结余',
    AvailableBalance: '可用结余',
    OutstandingAmount: '未结算金额',
    ApprovalItem: '审核事项',
    mchtApproval: '商户审核',
    //商户管理
    Client: "商户管理",
    //公司资料
    CompanyInfo: '公司资料',
    Merchant: '商户名称',
    Merchant1: '商户名称',
    BusinessAddress: '业务地址',
    MailAddress: '邮寄地址',
    BRNo: '商业登记号码',
    Capital: '资本',
    YearsOfBusiness: '成立年数',
    IncorporationCountry: '成立地点',
    EmployeeNo: '雇员人数',
    MerchantType: '商户类型',
    MerchantCategory: '商户类目',
    OnlineMerchants: '线上商户',
    UnderLineMerchant: '线下商户',
    OwnershipType: '公司类别',
    LimitedCompany: '有限公司',
    Partnership: '合伙',
    SoleProprietor: '独资',
    Contractperson: '联系人 ',
    Contractperson1: '联系人 ',
    Email: '电邮地址',
    Position: '职位',
    Position1: '职位',
    OfficePhone: '公司电话',
    Mobile: '手机号码',
    Fax: '传真号码',
    Director: '董事',
    DirectorHKID: '董事身份证号码',
    DirectorPassport: '董事护照号码',
    Nationality: '国籍',
    overdue:'公司注册过期时间',
    //联络资料
    ContactInfo: '联系资料',
    URL: '网址',
    TargetLaunchDate: '预定服务推出日期',
    TechnicalContact: '技术联系人',
    Email: '电邮',
    PhoneNo: '联系电话',
    OperationContact: '营运联系人',
    FinanceContact: '财务联系人',
    //业务资料
    BusinessInfo: '业务资料',
    BusinessNature: '业务性质',
    ProductsServices: '产品 / 服务类别',
    TargetCustomers: '目标顾客',
    provider: '现在/曾经使用的支付服务',
    Turnover: '过去两年营业额',
    LastYearSalesVol: '去年度营业额',
    YearBeforeSales: '前年度营业额',

    //互联网上提供的服务
    OnlineBusiness: '网上业务资料',
    DeliveryProvider: '送货供应商',
    CustomerHotline: '客户服务热线',
    ReturnRefundPolicy: '退换货政策',
    FulfuillmentTime: '收单至送货需时',
    ReceiptProvided: '有否签收',
    ForecastMonthlySales: '预算每月营业额',
    After3Months: '三个月后',
    After6Months: '六个月后',
    After1Year: '一年后',
    NoOfTransactions: '每月交易宗数',
    SalesVolume: '每月营业总额',
    AvgTransactionAmount: '每宗交易平均金额',
    MinTransactionAmount: '每宗交易最低金额',
    MaxTransactionAmount: '每宗交易最高金额',
    //结算资讯登记
    SettlementInfo: '清/结算资料',
    AccountName: '账户名称',
    AccountNo: '账户号码',
    BankName: '银行名称',
    BankCode: '银行编号',
    BankCode1: '银行编号',
    BranchCode: '分行编号',
    Address: '银行地址',
    SWIFT: '银行国际代码',
    ServiceChargeRate: '手续费率',
    ServiceChargeRate1: '微信支付手续费率（%）',
    ServiceChargeRate2: '微信支付MO手续费率（%）',
    ServiceChargeRateHK: '微信支付HK手续费率（%）',
    ServiceChargeBearer: '微信支付手续费承担方',
    ServiceChargeBearer1: '手续费承担方',
    Customer: '顾客',
    Consumer: '消费者',
    //附件
    Attachments: '附件',
    BR: '商业登记证',
    CertOfIncoporation: '公司注册证明',
    DirectorHKID1: '董事身份证或护照',
    BankStatement: '公司银行月结单',
    Photos: '公司或店铺照片',
    Logo: '商户图标',
    //店铺
    ShopInfo: '店铺资料',
    ShopModiify: '店铺修改',
    ShortName: '简称',
    ShopPhotos: '店铺照片',
    NewShop: '新增店铺',
    PendingShopApproval: '待审批店鋪',
    Sector: '行业',

    // 2.4新增字段
    company: '上级公司名称',
    companyID: '上级公司编号',
    firm: '公司',

    // V2.7
    WhiteLable: '白标',
    DescriptionOfGoods: "商品名称",

    // V2.10 银联需求
    UnionpaMerchantNo: '银联商户号',
    UnionpayFeeRate: '银联手续费率(%)',
    TerminalNo: '终端号',
    AugsPayUsername: 'AugsPay用户名',
    NotifyKey: '回调密钥',
    APIKey: '接口密钥',
    SignKey: '签名密钥',
    AugsPayFeeRate: 'AugsPay手续费率(%)',
    pleaseInputUnionpayFeeRate: '请填写银联手续费率',
    pleaseInputTerminalNo: '请填写终端号',
    pleaseInputNotifyKey: '请填写回调密钥',
    pleaseInputAPIKey: '请填写接口密钥',
    pleaseInputSignKey: '请填写签名密钥',
    pleaseInputUnionpayKey: '请填写银联密钥',
    pleaseInputAugsPayFeeRate: '请填写AugsPay手续费率',
    UnionpaMerchantNoAlreadyExists: '银联商户号已存在',
    AugsPayUsernameAlreadyExists: 'AugsPay用户名已存在',
    MopPayUsernameAlreadyExists: 'MopPay用户名已存在',
    alipayMerchantNo: '支付宝(直连)商户号',
    alipayFeeRate: '支付宝(直连)手续费率(%)',
    alipayDirect: '支付宝(直连)',
    DirectOnline:'支付宝直连(线上)',
    DirectOffline:'支付宝直连(线下)',
    key: '密钥',
    merchantNo: '商户号',
    AugsPay: 'AugsPay',
    userName: '用户名',

    // V2.13
    alipayOnline: '支付宝(线上)',
    alipayOffline: '支付宝(线下)', //v2.14
    ConfirmToReset: '确定重置',
    sPassword: '的密码吗?',
    resetPassword: '重置密码',

    abbreviation: '简称',
    merDescription: '商户简介',
    tooShort: '商户简介过短',
    tooLong: '商户简介过长',
    delete: '确定删除该商户吗',
    channelRegistration: '自动进件中',

    //v2.19新增澳门通道字段
    deviceNumber: '设备号',
    shopNumber: '店铺门牌号',
    // v2.23新增字段
    mcInformationForm:'商户信息表',
  },
  //代理商
  agent: {
    certificate:"公司注册文件编号",
    agent: '代理商',
    DirectMerchants: '直营商户数',
    BDStaff: '业务员数',
    SubordinateAgents: "下级代理商数",
    agentApproval: '代理商审核',
    agentApproval1: '代理商审核',
    //代理商详情 新增 修改
    BasicInfo: '基本资料',
    CompanyInfo: "公司资料",
    Name: '名称',
    Type: '类型',
    Address: "地址",
    MailAddr: '邮寄地址',
    Contact: '联系人',
    PhoneNo: '座机',
    MobileNo: '手机',
    UpperLevelAgent: '上级代理商名称',
    UpperLevelID: '上级代理编号',
    //结算资料
    SettlementInfo: '结算资料',
    Method: '结算方式',
    Bank: '银行',
    //佣金资料
    CommissionInfo: '佣金资料',
    Scanner: '扫码器',
    SubscriptionFee: '加盟费',
    OfflineBase: '线下基率(%)',
    OfflineComm: '线下佣金(%)',
    OnlineBase: '线上基率(%)',
    OnlineComm: '线上佣金(%)',
    EndDate: '结束日期',
    BDStaffNo: '业务员编号',
    commissionRatio: '业务员佣金 (%)',
    hintInfo: "基率为手续费不参与分佣计算的部分，其余手续费将按所填写的佣金比例与代理商进行分佣。例如，某个商户的手续费率为 1.5%，其代理商的基率为 1%，佣金比例为 50%，那么（1.5% - 1%）即为参与分佣的手续费率，代理商获得其中佣金的 50%，即（1.5% - 1%）* 50% = 0.25%，则该代理商可获得的佣金为其发展的商户的交易额的 0.25%",

    //V2.15
    POS: 'POS 采购',
    POSmargin: 'POS 按金',
    POSrentalMonth: 'POS 租金/月',
    ScannerPurchase: '扫码器采购',
    ScannerMargin: '扫码器按金',
    ScannerRentalMonth: '扫码器租金/月',
    AlipayCross: '支付宝(跨境钱包)',
		AlipayHK: '支付宝(本地钱包)',

		// v2.20
    WithdrawalRatio:'最低不可提现比例 ',
  },
  //业务员
  salesman: {
    Salesman: '业务员',
    Name: '姓名',
    ID: '身份证号码',
    ID1: '身份证号码',
    OK: '新增',
    Status: '当前状态',
    NewBDStaff: '新增业务员',
    ModifyTheSalesmanInformation: '修改业务员信息',
    theSalesman: '该业务员吗?',
    delete: '确定删除该业务员吗',
  },
  //机构
  mec: {
    Name1: '机构名称',
    Status: '机构状态',
    Contact: '联系人名称',
    Phone: "联系人电话",
    Detail: '机构详情',
    //机构详情
    OrganizationInfo: '机构信息',
    RegisterAddress: '机构注册地址',
    businessLicenseNo: "营业执照号",
    validityTime: '营业执照有效期',
    LegalPerson: '法人姓名',
    certificateType: '法人证件类型',
    certificateNo: '法人证件号码',
    PhoneNo: '法人联系电话',
    CreationTime: '入网时间',
    CreationTime1: '入网时间',
    Contact: '联系人信息',
    Name: '姓名',
    PhoneNo: '电话',
    PhoneNo1: '电话',
    Email: '电邮',
    //结算信息
    SettlementInfo: '结算信息',
    SettlementBank: '清算银行名称',
    City: '银行所在城市',
    AccountType: '账户类型',
    AccountName: '开户人名称',
    AccountNo: '结算账户号码',
    PhotoInfo: '照片资料',
    LegalPersonIDFrontPicture: '法人身份证正面照',
    LegalPersonIDReversePicture: '法人身份证反面照',
    LegalPersonBankcardFrontPicture: '法人银行卡正面照',
    LegalPersonBankcardReversePicture: '法人银行卡反面照',
    BusinessLicense: '营业执照',
    TaxRegistrationCertificate: '税务登记证照',
    OrganizationCodeCertificate: '机构代码证',
    CompanyFrontPicture: '公司正面照',
    CompanyLogo: '公司Logo',
    other: '其他',
  },
  //澳洲商户进件
  AuMer: {
    CompanyInfomation: '公司信息',
    RegistrationName: '公司名称',
    AustraliaBusinessNumber: '澳洲商业注册号',
    BusinessInfomation: '业务范围',
    Website: '公司网站',
    ContactNumber: '公司电话',
    CompanyDescripption: '公司简介',
    Address: '公司地址',
    City: '城市',
    Postcode: '邮编',
    State: '州',
    ContactInfomation: '联系方式',
    FullNmae: '全名',
    JobTitle: '职称',
    TelephoneNo: '电话号码',
    EmailAddress: '邮箱地址',
    BillingInfomation: '公司银行账户信息',
    BankName: '银行名称',
    CompanyAccountNmae: '账户名',
    BSB: '分行代码',
    AccountNumber: '账户',
    Rate: '费率',
    SettlementPeriod: '结算周期',
    OtherInformation: '其他资料',
  },
  //设备管理
  inputBox: {
    merchantName: '商户名称',
    exchangeRate: '汇率',
    deviceNum: '设备编号',
    bindingsStartDate: '绑定时间',
    endDateOfBinding: '',
    query: '查询',
    add: '添加',
    empty: '清空',
    serialNumber: '序号',
    merchantNumber: '商户编号',
    shopNumber: '店铺编号',
    shopName: '店铺名称',
    deviceState: '设备状态',
    weChatSonMerchant: '微信子商户号',
    storageTime: '入库时间',
    bindingTime: '绑定时间',
    modificationTime: '修改时间',
    operation: '操作',
    modify: '修改',
    cancel: '取消',
    ok: '确定',
    deviceAdd: '设备添加',
    deviceModify: '设备修改',
    newDeviceNumber: '新设备号',
    pleaseEnterTheNewDeviceNumber: '请输入新设备号',
    pleaseEnterTheStoreNumber: '请输入店铺编号',
    pleaseEnterTheDeviceNumber: '请输入设备编号',
    // 2.5新增字段
    pleaseEnterTheWalletType: '请选择钱包类别', // 2.6废弃
    pleaseEnterTheChannel: '请选择通道', // 2.6新增
    success: '成功',
    fail: '失败',
    modifySuccess: '修改成功',
    addSuccess: '添加成功',
    addFail: '添加失败',
    queryErr: '查询条件输入错误或查询结果不存在',
    //固码
    QRcode: '固码',
    fixedCodeID: '固码ID',
    codeNo: '码号',
    generationDate: '生成日期',
    bindingDate: '绑定日期',
    currentState: '当前状态',
    paymentChannel: '支付通道',
    channelNumber: '通道编号',
    companyNumber: '公司编号',
    channelState: '通道状态',
    costRate: '成本费率(%)',
    typeOfTransaction: '交易类型',
    settlementType: '结算类型',
    fixedFee: '固定手续费',
    priorityLevel: '优先级别',
    dateOfEntry: '录入日期',
    remarks: '备注',
    remarks1: '备注',
    channelRegistrationDate: '通道注册日期',
    autograph: '签名',
    adapterOrder: '适配器下单URL',
    paymentAdapter: '适配器代付URL',
    adapterCallback: '适配器回调URL',
    //固码 输入框
    startDate: '开始日期',
    endDate: '结束日期',
    unbound: '未绑定',
    bindings: '已绑定',
    disable: '停用',
    enable: '启用',
    minimumExchangeRate: '最小汇率',
    maximumExchangeRate: '最大汇率',
    receivablesArea: '收款区域',
    Australia: '澳大利亚',
    HongKong: '香港',
    pleaseEnterTheMerchantName: '请输入商户名称',
    chooseBranch: '选择分店',
    bindingNumber: '绑定数量',
    companySZ: '深圳前寶通信息科技有限公司',
    distributionFixedCode: '分配固码',
    toTheMerchant: '给商户',
    toTheAgent: '给代理',
    pleaseEnterTheMerchantName: '请输入商户名称',
    generatingAndBindingSolidCode: '生成并绑定固码',
    pleaseEnterTheAgentNumber: '请输入代理商编号',
    generatingFixedCode: '生成固码',

    // 2.3新增字段
    deviceID: '设备编号',
    deviceType: '设备类型',
    scanner: '派派小盒',
    // QRCode:'固码',
    deviceStatus: '设备状态',
    enabled: '已启用',
    disabled: '已停用',
    merchant: '所属商户',
    shop: '所属店铺',
    deploymentDate: '投用日期',
    search: '搜索',
    clear: '清空',
    status: '状态',
    // enable:'启用',
    // disable:'停用',
    change: '修改',
    cancelBinding: '取消绑定',
    confirmToDisable: '确定停用',
    confirmToEnable: '确定启用',
    confirmToUnbind: '确定取消绑定',
    confirmToEnableS: '确定启用',
    confirmToDisableS: '确定停用',
    QRCodeOf: '的固码吗?',
    scannerOf: '的派派小盒吗?',
    pleaseChooseMerchant: '请先选择所属商户',
  },
  // 2.3新增字段
  // 新增设备
  device: {
    newDevice: '新增设备',
    merchant: '所属商户',
    shop: '所属店铺',
    type: '设备类型',
    scanner: '派派小盒',
    QRCode: '固码',
    deviceID: '设备编号',
    OK: '确定',
    cancel: '取消',
    deviceNAE: '设备编号已存在',
  },
  // 2.3新增字段
  // 兑现
  newcash: {
    // 兑现审核
    requestDate: '申请时间',
    merchantName: '商户名称',
    bankName: '银行名称',
    agentName: '代理商名称',
    bankAccount: '银行账户',
    accountName: '账户名称',
    withdrawAmount: '提现金额',
    Arrived:"到账金额",

    withdrawAmount2: '提现金额',
    withdrawType: '提现类型',
    withdrawFee: '提现手续费',
    remitAmount: '打款金额',
    status: '状态',
    pending: '未审核',
    approved: '审核通过',
    rejected: '驳回',
    rejected1: '审核驳回',
    paid: '已打款',
    operation: '操作',
    approve: '通过',
    reject: '驳回',
    paid: '已打款',
    confirmToApprove: '确定通过',
    confirmToRefuse: '确定驳回',
    withdrawRequestFrom: '的提现申请吗?',

    // 兑现页
    merchantName: '商户名称',
    withdrawStatus: '提现状态',
    approvalTime: '审核时间',
    paymentTime: '打款时间',
    Withdrawal: "提现",
    Withdrawal1: "财务",
    WithdrawalRecord: "提现记录",
    pendingWithdrawalApproval: '兑现审核',

    // 2.4新增字段
    agentOrMerchantName: '代理商/商户名称',
    agentOrMerchantID: '代理商/商户编号',

    // 2.6新增字段
    withdrawErrorTitle: '提示',
    withdrawError: '以下商户提现失败，请重试：',
    none: '无',
    withdrawalConfirmation: '提现确认',
  },
  // 2.3新增字段
  // 云账号
  cloudAccount: {
    switchInstitution: '切换机构',
    pleaseSelectInstitution: '请选择机构',
  },
  // 2.4新增字段
  // 资金管理
  fund: {
    withdrawAmount: '提现账户及金额',
    enterAmount: '输入金额',
    withdraw: '提现',
    cheque: '支票付款',
    bankTransfer: '银行转账',
    transferTip: '建设/中银转账免手续费，跨行转账每笔HK$ 50',
    withdrawMethod: '提现方式',
    warning: '温馨提示',
    warningTitle: '提现时间（按工作日计算）：',
    warningText: '上午9:00前的申请当天出票或转账；其后的第二天处理',
    withdrawLimit: '提现金额不能小于',
    confirmWithdraw: '确定提现 ',
    confirmWithdrawSuffix: '吗?',
    success: '提现成功',
    failed: '提现失败',
    pending: '未审核',
    approved: '审核通过',
    rejected: '审核驳回',
		paid: '已打款',
		// V2.20
		WithdrawalAmount:'可提现金额',
    warningContent:'如有疑问请联系工作人员',
    Withdrawable:"(1)港币5元每笔汇款 (汇款金额少于或等于港币500,000元),",
    WithdrawableT:"(2)港币10元每笔汇款(汇款金额大于港币500,000元）",
    // v2.22
    see:'查看',
    rechargeRecord:'备用金充值记录',
    refundRecord:'备用金退款记录',
    imprestAudit:'备用金充值审核',
    please:'请',
    confirmRecharge: '确定充值',
    reserveMoney:'备用金余额',
    recharge:'充值',
    rechargeTime:'充值时间',
    refundTime:'退款时间',
    rechargeRecords:'充值记录',
    refundRecords:'退款记录',
    rechargeAmount:'充值金额',
    refundAmount:'退款金额',
    rechargeNotes:'充值备注',
    rechargeVoucher:'充值凭证',
    fillRemarks:'填写备注',
    rechargeRechargeInfo:'备用金充值信息',
    reserveWarningTitle:'备用金余额仅用作商户退款使用,充值后不可提现,如需提现，请联系工作人员;',
    reserveWarningText:'如需充值备用金，请提前打款并保留打款凭证;',
    reserveWarningContent:'充值金额需与凭证中金额相符,提交充值后将有工作人员审核凭证信息,审核通过方可使用备用金余额进行退款。',



  },
  // 2.4新增字段
  // 分润管理
  profit: {
    profit: '分润',
    countDate: '结算日期',
    date: '日期',
    acquirerFee: '机构分润',
    channel: '渠道',
    channelFee: '渠道分润',
    agentComm: '代理商分润',
    BDComm: '业务员分润',
    settlement: '结算金额',
    acquirerFeeTotal: '机构分润总额',
    agentCommTotal: '代理商分润总额',
    BDCommTotal: '业务员佣金总额',
    wx: '微信',
    payment: '结算收款',
    settlementDateRefund: '结算退款',
  },
  // 2.4新增字段
  // 公司管理
  firm: {
    companyName: '公司名称',
    companyID: '公司编号',
    agent: '上级代理商名称',
    companyStatus: '公司状态',
    establishmentDate: '入网时间',

    // 公司列表
    name: '公司名称',
    ID: '公司编号',
    status: '状态',
    merchantQty: '直属商户数',
    registrationDate: '入网时间',
    companyApproval: '公司审核',
  },
  // 商户提现
  cash: {
    userNumber: '用户编号',
    auditStatus: '审核状态',
    unaudited: '未审核',
    reviewAndPassThrough: '审核通过',
    reviewAndDismissal: '审核驳回',
    alreadyMadeMoney1: '已打款',
    presentType: '提现类型',
    check: '电子支票',
    onlineBanking: '银行转账',
    applicationStartDate: '申请时间',
    applicationEndDate: '',
    userNumber: '用户编号',
    companyName: '公司名称',
    applicationTime: '申请时间',
    auditStatus: '审核状态',
    presentType: '提现类型',
    amountOfCash: '提现金额',
    cankCardNumber: '银行卡号',
    cardholder: '持卡人',
    bankName: '银行名称',
    auditTime: '审核时间',
    remittanceDate: '汇款时间',
    notes: '注释',
    examine: '审核',
    adopt: '通过',
    reject: '驳回',
    playMoney: '打款',
    auditHasPassed: '审核已通过,可打款',
    theAuditHasBeenRejected: '审核已驳回,无法进行操作',
    errOperation: '错误操作!已打款',
    alreadyPassed: '审核已通过,不能驳回',
    notRepeatOperation: '审核已驳回,请勿重复操作',
    audit: '审核中',
    notMakeMoney: '审核已驳回,无法打款',
    alreadyMadeMoney: '已打款,请勿重复操作',
    query: '查询',
    empty: '清空',
  },
  //店铺
  shop: {
    Phone: "联系人电话",
    Phone1: "联系人电话*",
    Email: '电邮',
    Email1: '电邮*',
    shopApproval: '店铺审核',
    shopName: '店铺名称',
  },
  // v2.2新增字段
  // 修改密碼
  modifyPwd: {
    PasswordChange: '修改密码',
    OriginalPassword: '原密码',
    NewPassword: '新密码',
    Confirm: '确认密码',
    OK: '确定修改',
    Cancel: '取消',
    PasswordIncorrect: '密码输入错误',
    NewPasswordLessThan6Digits: '新密码少于6位字符',
    TheTwoPasswordsDoNotMatch: '两次密码不一致',
    TheNewPasswordIsTheSameAsTheOldOne: '新密码与原密码相同',
    PleaseInputMoreThan6DigitsPassword: '（请输入6位以上密码）',
    PleaseBeTheSameAsOriginalPassword: '（请与新密码一致）',
    PleaseInputOriginalPassword: '请输入原密码',
    PleaseInputPasswordAgain: '请再次输入密码',
    PleaseInputPassword: '请输入密码',

    formatError: '图片格式不正确',
  },
  other: {
    PhoneNumberAlreadyExist: '业务员联系电话已存在',
    InformationChange: '修改资料',
    ConfirmToMakeTheChanges: '确定修改店铺资料吗?',
    ConfirmToRegisterTheShop: '确定新增该店铺吗?',
    ConfirmToDeleteTheShop: '确定删除该店铺吗?',
    MerchantLogo: '商戶Logo',
    MerchantInfo: '商户信息登记表',
    PasswordShouldBeAtLeast6Characters: '密码不能少于6位',
    EmailAlreadyExists: '业务员邮箱已存在',
    EstablishmentFrom: '入网时间',
    EstablishmentFrom1: '入网时间',
    EstablishmentFrom2: '入网时间',
    EstablishmentFrom3: '入网时间',
    EstablishmentTo: '',
  },
  modifyShop: {
    ShopDetail: '进入店铺',
    New: '添加店铺',
    Back: '返回上一层',
    Rejected: '审核未通过!',
    ApprovalPending: '店铺审核中...',
    AmendmentApprovalPending: '修改资料审核中...',
    UploadPhoto: '上传图片',
    ShopNumber: '店铺编号',
    Edit: '修改信息',
    Suspended: '已停用!',
    ClickToAddPhotos: '点击添加图片',
    ShopName: '填写店名',
    OK: '完成',
    OK1: '提交',
    delete: '删除店铺',
  },
  ad: {
    typeOne: '类型一',
    typeTwo: '类型二',
    typeThree: '类型三',
    advertisingPosition: '广告位',
    resolution: '分辨率',
    link: '链接',
    adMgmt: '广告',
    adSetup: '广告',

    // V2.9
    NewAdvertisement: '添加广告',
    BusinessNature: '广告行业',
    ConfirmtodeletetheAdvertisement: '确定删除该条广告吗?',
    ConfirmtomodifytheAdvertisement: '确定修改该条广告吗?',
    Replacethepicture: '更换图片',
    Uploadpicture: '上传图片',
    AdvertisementName: '广告名称',
    Link: '跳转链接',
    PleaseAddAdvertisementPicture: '请添加广告图片',

    // V2.14
    adData: '广告数据',
    Display: '曝光量',
    Click: '点击量',
    ClickRate: '点击率',
  },
  // V2.7
  // 商户结算
  settlement: {
    Date: '结算日期',
    Merchant: '商户名称',
    MerchantID: '商户编号',
    SettlementPeriod: '结算周期',
    TransactionAmount: '交易总额',
    Fee: '手续费',
    SettlementAmount: '结算总额',
    Settlement: '商户结算',
    // v2.23字段
    refundRemarks:'退款备注'
  },
  // 意见管理
  opinion: {
    Date: '日期',
    SuggestionList: '意见列表',
    SuggestionList1: '意见列表',
    SuggestionList2: '意见列表',
    Time: '时间',
    Shop: '店铺',
    Account: '账户',
    AcountName: '账户名称',
    Role: '角色',
    Subject: '主题',
    Content: '内容',
    Suggestion: '反馈详情',
  },
  // 2.10  通知管理
  notify: {
    title: '通知主题',
    content: '',
    content1: '通知内容',
    NotificationHistory: '通知记录',
    Recipients: '收件人',
    Details: '详情',
    EditNotification: '通知编辑',
    SelectRecipients: '选择收件人',
    SendTo: '发送至:',
    Send: '发送',
    All: '全部',
    Agent: '代理商',
    Company: '公司',
    Merchant: '商户',
    Finance: '财务',
    BD: '业务员',
    AllAgent: '所有代理商',
    AllCompany: '所有公司',
    AllMerchant: '所有商户',
    AllMerchantAdministrator: '所有商户管理员',
    AllShop: '所有店铺',
    AllStaff: '所有员工',
    AllFinance: '所有财务',
    AllBD: '所有业务员',
    Administrator: '管理员',
    MerchantsOf: '直屬商户',
    ConfirmToSend: '确定发送?',
    Notification: '通知',
    AlreadyExists: '已存在',
    PleaseSelectRecipients: '请选择收件人',
    Notifications: '消息通知',
    NotificationList: '消息列表',
    NofiticationDetails: '消息详情',
    contentExceeding: '内容超过2000字符,请删减内容',
    Only10Images: '每篇通知只允许上传 10 张图片',
    pleaceSelectOrEnputMerchantName: '请选择/输入商户名',
    addPicture: '添加图片',

    // V2.15新增
    Merchant: '商户',
    Agent: '代理商',
    Company: '公司',
    Shop: '店铺',
    registrationApproved: '进件审核通过',
    registrationRejected: '进件审核驳回',
    informationModificationApproved: '修改信息审核通过',
    informationModificationRejected: '修改信息审核驳回',
    withdrawalApplicationApproved: '兑现申请审核通过',
    withdrawalApplicationRejected: '兑现申请审核驳回',
    the: '您提交的',
    registrationYouSubmittedHasBeenApproved: '进件申请已通过审核',
    registrationYouSubmittedHasBeenRejectedRejectReason: '进件申请被驳回，驳回原因：',
    informationModificationYouSubmittedHasBeenApproved: '修改信息申请已通过审核',
    informationModificationYouSubmittedHasBeenRejectedRejectReason: '修改信息申请被驳回，驳回原因：',
    theWithdrawalApplicationOf: '您于',
    on: '提交的',
    youSubmittedHasBeenApproved: '兑现申请已通过审核',
    youSubmittedHasBeenRejectedRejectReason: '兑现申请被驳回，驳回原因：',
	},
  // 风控
  risk: {
    report:'交易报告',
    automated:'报告列表',
    should:'报告日期',
    Type: '风控类型',
    Edit: '修改',
    Remove: '移除',
    NewWhiteList: '添加白名单',
    Configuration: '规则设置',
    PassingRules: '放行规则',
    DayAmountLimit: '单日限额',
    HourAmountLimit: '小时限额',
    PerTransactionLimit: '单笔限额',
    MinuteVolumeLimit: '分钟限频',
    ConfirmWhiteRemoving: '确定从白名单中移除',
    FromWhiteList: '吗?',
    Abnormalty: '异常交易',
    BlackListed: '转为黑名单',
    OrderNumber: '订单号',
    ConfirmGreyRemoving: '确定从灰名单中移除',
    fromGreyList: '吗?',
    ConfirmMoving: '确定将',
    toBlackList: '转移到黑名单吗?',
    GreyListed: '转为灰名单',
    ConfirmBlackRemoving: '确定从黑名单中移除',
    fromBlackList: '吗?',
    toGreylist: '转移到灰名单吗',
    ConfirmChanging: '确定修改',
    ConfirmChangingRiskControlfactors: '确定修改该行业的风控参数吗?',
    RiskControl: '风险控制',
    whiteListEdit: '白名单修改',
    whiteList: '白名单',
    greyList: '灰名单',
    blackList: '黑名单',
    items: '笔',
    // v2.23新需求
    riskMerchant:'商户风控',
    riskTime:'风控时间',
    singleDayLimit:'单日限额',
    singleLimit:'单笔限额',
    addRiskMerchant:'添加风控商户',
    removeRiskMerchant:'移除风控商户',
    modifyRiskMerchant:'修改风控商户',
    isDeleteRiskMerchant:'是否确认从风控列表中移除该商户？',
    adder:'添加者',
    verifyIsEmpty:'商户名称/编号不得为空',
    minLimitRules:'请至少输入一项限额规则',
    VerifyDcMcName:'该商户已存在，请重新选择',
    // v2.32
    TradingLimit:'交易限频',
    pen:'笔'
  },
  // 审核记录
  History: {
    Applicant: '申请人',
    ApplicantAccount: '申请人账户',
    ApprovalHistory: '审核记录',
    Approver: '审核人',
    ApproverAccount: '审核人账户',
    Agent: '代理商',
    Company: '公司',
    Merchant: '商户',
    shop: '店铺',
    refusalReasons: '驳回原因',
  },
  // V2.12 统计
  count: {
    month: '月',
    week: '周',
    day: '日',
    hour: '时',
    pleaceSelectTime: '请选择时间',
    endTimeError: '结束时间错误',
    pleaseSearchLessThan24Months: '搜索时间请勿超过24个月',
    pleaseSearchLessThan16Weeks: '搜索时间请勿超过16周',
    pleaseSearchSessThan62Days: '搜索时间请勿超过62天',
    pleaseSearchSessThan48Hours: '搜索时间请勿超过48小时',
    todayReceiptAmount: '今日收款总额',
    todayUnionPayAmount:'今日银联收款总额',
    todayWeChatAmount:'今日微信收款总额',
    todayHongKongAmount: '今日香港微信总额',
    todayWalletAmount:'今日跨境微信总额',
    todayAlipayAmount:'今日支付宝收款总额',
    todayTransactionVolume: '今日交易量',
    transactionAmount: '交易额',
    transactionVolume: '交易量',
    newMerchant: '新增商户',
    date: '日期',
    amount: '交易额',
    top10Merchant: 'Top10商户',
    Month: '月',
    sinceEstablishment: '开通以来',
    dataSheet: '数据表',
    ranking: '排行',
    failureRate: '失败率',
	},
	// V2.20  用户信息
	user:{
		title:'用户信息',
		tips:'(点击编辑用户名和头像)',
		placeholder:'请输入（回车确认）',
		qualified1:'请输入用户名',
		qualified2:'请正确输入用户名',
		qualified3:'用户名不得含有中英文的特殊字符',
		OK:'确定',
		Cancel:'取消'
	},

  zhCNLocale // 或者用 Object.assign({ message: '你好' }, zhLocale)
}



// WEBPACK FOOTER //
// ./src/common/lang/zh-cn.js